export default __webpack_public_path__ + "static/myschedulr-image-009cd7e6ab1f869621798aead7407b54.svg";